import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TimeUtilities } from '@evorait/pace-core';
import moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';

const maxHourAmount = 24;
const maxMinuteAmount = 59;

@Component({
    selector: 'pace-forms-duration-manual-input',
    templateUrl: './forms-duration-manual-input.component.html',
    styleUrls: ['./forms-duration-manual-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FormsDurationManualInputComponent implements OnInit {
    @Input()
    public duration: string;

    @Output()
    public modelChanged = new EventEmitter<string>();

    public maxHourAmount = maxHourAmount;
    public maxMinuteAmount = maxMinuteAmount;

    public hours: number;
    public minutes: number;
    public constructor(public readonly modalInstance: BsModalRef) {}

    public ngOnInit(): void {
        const duration = moment.duration(this.duration);
        this.hours = duration.hours();
        this.minutes = duration.minutes();
    }

    public onSave(): void {
        const enteredDuration = TimeUtilities.getFormattedDuration(this.hours, this.minutes);
        this.modelChanged.emit(enteredDuration);
        this.modalInstance.hide();
    }
}
